import { initializeI18n } from '@inbody/core';

/*
  패키지(@inbody/ui · @inbody/keycloak)가 자기 i18n 리소스를 side-effect 로
  등록한다 — 이 glob 이 그 등록을 일으킨다. 없으면 'ui' · 'keycloak'
  네임스페이스가 비어 라벨이 키 문자열로 보인다.
*/
import.meta.glob('../../../../../packages/*/src/i18n/index.ts', {
  eager: true,
});

/**
 * IPH i18n 초기화.
 *
 * 🚨 **번역이 필요해서 넣은 것이 아니다.** IPH 화면 문구는 한국어로 박혀 있다.
 * 공용 컴포넌트(`@inbody/ui`)와 그 안의 `useCorporate` 가 `useTranslation` 을
 * 쓰는데, i18n 이 초기화돼 있지 않으면 `i18n.language` 가 undefined 라
 * `language.split('-')` 에서 화면이 죽는다(권한 관리 '사용자별' 모드의
 * CorporateSelector).
 *
 * 그래서 앱 리소스는 더하지 않고 초기화만 한다 — 패키지 리소스는 위 glob 이 싣는다.
 *
 * 한국어 전용 앱이라 언어 감지를 끄고 기본값(ko)으로 고정한다. 헤더 언어 전환은 숨겼는데
 * 감지기는 브라우저 언어를 따라가서, 영어 브라우저에서는 공용 부품만 영어로 섞여 나왔다.
 */
initializeI18n({ detection: { order: [], caches: [] } });
